import { Link } from 'react-router-dom'
import { Clock, Mail, MapPin, Phone } from 'lucide-react'

const details = [
  { icon: Phone, label: '+52 55 2378 5783', href: 'tel:+525523785783' },
  { icon: Mail, label: 'alejandroflorero4@gmail.com', href: 'mailto:alejandroflorero4@gmail.com' },
  { icon: MapPin, label: 'Centro Deportivo Xochimilco', href: '/contact' },
  { icon: Clock, label: 'Martes y jueves · 9:30–13:00' },
]

const socials = [
  { label: 'Facebook', href: 'https://www.facebook.com/AsociacionNacionalDeGolfAdaptadoAc' },
  { label: 'Instagram', href: 'https://www.instagram.com/asociaciongolfadaptadomexico' },
]

const Qr = () => (
  <div className="flex min-h-screen items-center justify-center bg-ivory px-4 py-16">
    <article className="w-full max-w-md overflow-hidden rounded-[2rem] bg-white ring-1 ring-leaf/10">
      <header className="bg-fairway px-8 py-10 text-center text-cream">
        <p className="eyebrow text-sun">Desde 2012</p>
        <h1 className="mt-3 font-serif text-3xl leading-tight">Asociación Nacional de Golf Adaptado</h1>
        <p className="mt-3 text-sm text-cream/75">Clases gratuitas en Xochimilco.</p>
      </header>

      <div className="px-8 py-8">
        <ul className="space-y-3">
          {details.map((item) => {
            const Icon = item.icon
            const content = (
              <>
                <Icon className="h-4 w-4 shrink-0 text-leaf" aria-hidden="true" />
                <span>{item.label}</span>
              </>
            )
            return (
              <li key={item.label} className="text-sm text-ink">
                {item.href?.startsWith('/') ? (
                  <Link to={item.href} className="flex items-center gap-3 hover:text-leaf">{content}</Link>
                ) : item.href ? (
                  <a href={item.href} className="flex items-center gap-3 hover:text-leaf">{content}</a>
                ) : (
                  <p className="flex items-center gap-3">{content}</p>
                )}
              </li>
            )
          })}
        </ul>

        <img
          src="/qr-code.png"
          alt="Código QR de la Asociación Nacional de Golf Adaptado"
          className="mx-auto mt-8 h-48 w-48"
        />

        <ul className="mt-8 flex justify-center gap-3">
          {socials.map((item) => (
            <li key={item.label}>
              <a
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full bg-cream px-4 py-2 text-sm font-semibold text-leaf hover:bg-leaf hover:text-white"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </article>
  </div>
)

export default Qr
